module.exports = require('./lib/create-wix-data').default
